export default {
  video: {
    desc: 'Su billetera de hardware cripto segura',
    preOrderNow: 'Comprar',
    watchNow: 'Ver ahora',
  },

  introduce: {
    title:
      'KeyPal — Combinando seguridad y facilidad de uso, mostrando todas sus ventajas',
    desc_1: 'Haga clic en cualquier tarjeta para obtener más información',
    desc_2: 'Conexión',
    desc_3: 'Seguridad',
    desc_4: 'Copia de seguridad',
    desc_5: 'Passphrase',
    desc_6: 'Autonomía',
    desc_7: 'Capacidad de la batería',
    desc_8: 'Doble chip',
    desc_9: 'Teclado de 15 teclas',
    desc_10: 'Múltiples formas de conexión, seguro hay una que se adapta a ti',
    desc_11: 'NFC + KeyPal Card',
    desc_12: 'Uso',
    label_1:
      'Admite conexión de billetera y firma de transacciones mediante Bluetooth y escaneo de código QR',
    label_1_1:
      'Elija diferentes métodos de conexión según el escenario para que el uso del monedero de hardware sea más seguro y conveniente',
    label_2: 'KeyPal 2 admite Passphrase',
    label_2_1:
      'Con la misma frase de recuperación, puedes acceder a diferentes billeteras usando distintas Passphrases, añadiendo una capa extra de seguridad a tuassphras',
    label_3:
      'Compatible con NFC para copias de seguridad más simples y rápidas',
    label_3_1:
      'KeyPal 2 te permite respaldar rápidamente tu frase de recuperación en la KeyPal Card mediante NFC',
    label_4: 'Mayor capacidad de batería, de 300 mAh a 500 mAh',
    label_4_1:
      'Una sola carga dura hasta 12 horas, liberándote de la ansiedad por batería baja',
    label_5: 'KeyPal 2 adopta un diseño de doble chip de grado militar',
    label_5_1:
      'Con arquitectura MCU + SE, la seguridad comienza desde el núcleo',
    label_6:
      'Diseño de cuadrícula de 15 teclas para una entrada e interacción más sencilla',
    label_6_1:
      'Introduce contenido y selecciona funciones rápidamente, sin procesos largos y complicados',
  },

  support: {
    title: 'Millones de criptomonedas compatibles',
    desc_1: 'Ver lista de compatibilidad',
  },

  other: {
    title: 'Otros productos de KeyPal',
    desc_1: `KeyPal Plus cuenta con una arquitectura de doble chip que combina facilidad de uso y seguridad. Su diseño minimalista, junto con una carcasa de aleación de aluminio resistente, brinda una experiencia de gestión de activos digitales duradera y eficiente`,
    desc_2: `KeyPal Card es compatible con la comunicación NFC, lo que le permite guardar fácilmente sus frases mnemotécnicas y claves privadas con un solo toque. Combina perfectamente las funciones de copia de seguridad y firma sin conexión. Con un diseño del tamaño de una tarjeta bancaria, es portátil, segura y protege sus activos criptográficos en cualquier momento y lugar`,
    desc_3: `Secret Box está fabricado con acero inoxidable 304, lo que le otorga una resistencia excepcional a altas temperaturas y a la corrosión. Su diseño de bloques de letras y ranuras facilita y prolonga la conservación de la frase semilla. Con un diseño de doble cara A+B, admite el almacenamiento de frases de recuperación de 12×2, 18 o 24 palabras, proporcionando seguridad a largo plazo para tus activos criptográficos`,
  },

  FAQ: {
    title: 'FAQ',
    desc_1: 'Haz clic para ver todas las respuestas a las preguntas frecuentes',
    question_1: '¿Qué es una billetera cripto?',
    question_2: '¿Por qué necesito una billetera de hardware?',
    question_3:
      '¿Cuál es la diferencia entre una billetera de hardware y una de aplicación?',
    question_4:
      '¿Qué pasa si pierdo el dispositivo? ¿Mis criptoactivos siguen seguros?',
    question_5:
      '¿Qué tipos de criptomonedas admite la billetera de hardware KeyPal?',
  },

  discover: {
    title: 'Elige tus colores favoritos de KeyPal',
    desc_1: 'Descubrir',
  },

  instructions: {
    title: 'Centro de tutoriales',
    desc: 'Demostraciones completas para aprender fácilmente KeyPal 2, haciendo que la gestión de activos criptográficos sea simple y segura.',
    tabs: {
      hardware: 'Funciones del dispositivo',
      activation: 'Tutorial del dispositivo',
      connect: 'Conexión de cartera',
      upgrade: 'Actualización de firmware',
    },
    hardware: {
      basic: 'Operación básica',
      power: 'Encendido/Apagado',
      language: 'Selección de idioma',
      button: 'Operación de botones',
      features: 'Introducción de funciones',
      security: 'Configuración de seguridad',
      passphrase: 'Configurar passphrase',
      securityOverview: 'Descripción general de seguridad',
      verifyDevice: 'Verificar dispositivo',
      asset: 'Gestión de activos',
    },
    activation: {
      create: 'Crear frase semilla',
      createByDevice: 'Generar en dispositivo',
      import: 'Importar frase semilla',
      manualImport: 'Importación manual',
      keypalCardImport: 'Importar vía KeyPal Card',
      backup: 'Copia de seguridad',
      steelBackup: 'Copia/caja metálica',
      keypalCardBackup: 'Copia con KeyPal Card',
    },
    connect: {
      bluetooth: 'Conexión Bluetooth con TokenPocket',
      connectAndAdd: 'Conectar app y añadir dirección',
      qrConnect: 'Conexión por QR',
      qrConnectTP: 'Conexión QR a TokenPocket',
      qrConnectMM: 'Conexión QR MetaMask',
      transferReceive: 'Transferencia y recepción',
      bluetoothTransfer: 'Transferencia por Bluetooth',
      qrTransfer: 'Transferencia por código QR',
      receiveHardware: 'Recibir por el dispositivo',
      receiveApp: 'Recibir por la app',
      transfer: 'Transferir',
    },
    upgrade: {
      web: 'Actualizar vía página web',
      bluetooth: 'Actualizar vía Bluetooth',
      mobile: 'Actualizar desde móvil',
      troubleshoot: 'Resolución de fallos',
      webTroubleshoot: 'Resolución de fallos actualización web',
      bluetoothTroubleshoot: 'Resolución de fallos actualización Bluetooth',
    },
    relatedVideos: 'Videos relacionados',
    playing: 'Reproduciendo',
  },
};
